import { CompanySettingsEffect } from './company-settings.effects';

export const effects: Array<any> = [CompanySettingsEffect];

export * from './company-settings.effects';
